/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, March 4th 2022, 2:20:31 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { ManageTaskPermissions } from "service-builder/components/workflow-builder/ManageTaskPermissions";
import { ProcessDefinitionTeamsList } from "service-builder/components/process-definition/ProcessDefinitionTeamsList";
import { OSTabs } from "ui-widgets";

export const TeamAccessConfigurationPage = () => {
  const labels = ["Workflow Access", "Task Access"];
  const panels = [
    <div style={{ padding: 24, width: "55vw" }}>
      <ProcessDefinitionTeamsList />
    </div>,
    <div style={{ padding: 24, width: "55vw" }}>
      <ManageTaskPermissions />
    </div>,
  ];

  return (
    <div className="os-service-builder-card">
      <OSTabs tabLabels={labels} tabPanels={panels} />
    </div>
  );
};
